import React from 'react';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { getDeviationTitle } from '../../../_helpers';
import s from './FeedCardTitle.scss';
var FeedCardTitle = function (_a) {
    var deviation = _a.deviation, className = _a.className, _b = _a.disableScrollRestoration, disableScrollRestoration = _b === void 0 ? true : _b;
    return (React.createElement(Heading, { className: classnames(s['title'], className) },
        React.createElement(DeviationLink, { deviation: deviation, disableScrollRestoration: disableScrollRestoration }, getDeviationTitle(deviation))));
};
FeedCardTitle.displayName = 'FeedCardTitle';
export default FeedCardTitle;
//# sourceMappingURL=FeedCardTitle.js.map